import React from 'react'
import TopHeader from './TopHeader'
import TopNav from './TopNav'
import { useSelector } from 'react-redux'
import { selectSiteHeaderColor } from '../../../AsianExchangeSrc/utils/helper/commonSelectors'
import { useLocation } from 'react-router-dom'

function Header() {
  const location = useLocation();
  const headerColor = useSelector(selectSiteHeaderColor())

  return (
    <div style={{ display: "flex", flexDirection: "column", position: "relative" }}>
      <TopHeader headerColor={headerColor} />
      {
        !"/inplay, /sports, /full-market, /account, /myprofile, /multimarket, /rolling-commission, /account-statement, /bets-history, /profit-loss, /password-history, /activity-log, /settings, /deposit, /withdraw".includes(location.pathname) && <TopNav headerColor={headerColor} location={location} />
      }
    </div>
  )
}

export default Header